/**
 * Returns whether paymentEngine should be re-aligned with the selected payment method
 * after getPurchase + receivePurchase.
 *
 * When a redirect payment fails or is canceled, the purchase API may still expose the
 * previous attempt's engine (e.g. mercadopago, aplazo) while getPurchase resets the UI
 * selection to the tenant default. Re-applying selectPaymentMethod keeps Redux consistent
 * for PaymentForm without changing payment attempt logic.
 *
 * @param {object} params - Alignment params.
 * @param {string} [params.selectedMethodEngine] - Engine from the payment method just selected.
 * @param {string} [params.purchasePaymentEngine] - paymentEngine from the purchase API payload.
 * @param {number|string|null} [params.lastPaymentId] - Last payment id on the purchase, if any.
 * @returns {boolean} Whether selectPaymentMethod should run again after receivePurchase.
 */
export default function shouldAlignPaymentEngineWithSelection({
  selectedMethodEngine,
  purchasePaymentEngine,
  lastPaymentId,
}) {
  if (!lastPaymentId) return false;
  if (!selectedMethodEngine || !purchasePaymentEngine) return false;
  return selectedMethodEngine !== purchasePaymentEngine;
}
